if (!customElements.get('product-read-more')) {
  customElements.define(
    'product-read-more',
    class extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-prmcontent]');
        this.btn = this.querySelector('[data-prmtoggle]');
        this.btn?.addEventListener('click', () => this.toggle());
      }

      toggle() {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', String(!expanded));
      }
    }
  );
}
